module.exports = __webpack_public_path__ + "static/media/8p.20b49df1.png";